import { useState, useCallback } from "react";
import { updateDocumentURL } from "../../utils/ConstantsURL";

export const useUpdateDocument = (token) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const updateDocument = useCallback(
    async (documentData) => {
      setLoading(true);
      setError(null);
      
      try {
        const response = await fetch(updateDocumentURL(), {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(documentData),
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || "Error al actualizar el documento");
        }

        setData(result);
        return { success: true, data: result };
      } catch (err) {
        const errorMessage = err.message || "Error en la conexión";
        setError(errorMessage);
        return { success: false, error: errorMessage };
      } finally {
        setLoading(false);
      }
    },
    [token]
  );

  return { updateDocument, loading, error, data };
};

export default useUpdateDocument;
